import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from '../services';
import has = Reflect.has;
import {PermissionManagerService} from "../security/services/permissionManager.seervice";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService,
        private permissionManagerService: PermissionManagerService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.accountService.userValue;

        let canActivate = true;

        if (typeof route.data.module !== 'undefined') {
            if (typeof route.data.permission !== 'undefined') {
                canActivate = this.permissionManagerService.isGranted(route.data.module, route.data.permission);
            } else {
                canActivate = this.permissionManagerService.isGranted(route.data.module, 'READ');
            }
        }

        if (user) {
            // authorised so return true
            return canActivate;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}
